import { RotationPortCall } from 'src/types/ViewModel/Stowage/Rotation/RotationPortCall';
import { UUID } from 'crypto';
import { createStowagePlanChange } from '../StowagePlanChangeFactory';
import { StowageChangeDataType } from 'src/types/ViewModel/Stowage/Enums/StowageChangeDataType';
import { createSequenceChangeValue } from './SequenceChangeUtil';

export const createPortCallChangeData = (portCall: RotationPortCall): Partial<RotationPortCall> => {
    return {
        imosPortCallId: portCall.imosPortCallId,
        portId: portCall.portId,
        portOrderNumber: portCall.portOrderNumber,
        imoNumber: portCall.imoNumber,
        voyageNumber: portCall.voyageNumber,
        dataSource: portCall.dataSource,
        voyageStatus: portCall.voyageStatus,
        turnaroundVoyageNumber: portCall.turnaroundVoyageNumber,
        portCallStatus: portCall.portCallStatus,
        departureDateTimeLocal: portCall.departureDateTimeLocal,
        departureDateTimeUtc: portCall.departureDateTimeUtc,
        arrivalDateTimeLocal: portCall.arrivalDateTimeLocal,
        arrivalDateTimeUtc: portCall.arrivalDateTimeUtc,
        hasArrived: portCall.hasArrived,
        hasDeparted: portCall.hasDeparted,
        hasCorrectStatus: portCall.hasCorrectStatus,
        imosPortFunction: portCall.imosPortFunction,
    };
};

export const createPortCallOrderChange = (stowagePlanGuid: UUID, changeDataGuid: UUID, portOrderNumber: number, portCallData?: RotationPortCall) => {
    const hasChangedSequence = createSequenceChangeValue(portOrderNumber, portCallData, 'portOrderNumber');

    return createStowagePlanChange(stowagePlanGuid, changeDataGuid, StowageChangeDataType.RotationPortCall, {
        portOrderNumber,
        hasChangedSequence,
    });
};
